var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 10.1579C13.0557 10.1579 13.9114 10.9824 13.9114 12C13.9114 13.0176 13.0557 13.8421 11.9996 13.8421C10.9436 13.8421 10.0879 13.0176 10.0879 12M8.33846 7.82874C7.43304 7.32105 6.27604 7.62168 5.75375 8.5C5.23146 9.37905 5.54116 10.502 6.44657 11.0082C7.23193 11.4496 7.23193 12.5504 6.44657 12.9918C5.54116 13.4987 5.23146 14.6224 5.75375 15.5C6.27604 16.3783 7.43304 16.6789 8.33769 16.1727C9.12381 15.7314 10.1072 16.2825 10.1072 17.1638C10.1072 18.1777 10.9553 19 11.9998 19C13.0444 19 13.8917 18.1777 13.8917 17.1638C13.8917 16.2825 14.8751 15.7314 15.662 16.1727M18.2459 15.5C18.7689 14.6224 18.4585 13.4987 17.5538 12.9918C16.7677 12.5504 16.7669 11.4496 17.5538 11.0082C18.4585 10.502 18.7689 9.37905 18.2459 8.5C17.7228 7.62168 16.5658 7.32105 15.6619 7.82874C14.8751 8.26863 13.8916 7.71821 13.8916 6.83621C13.8916 5.82232 13.0444 5 11.9998 5C10.9552 5 10.1071 5.82232 10.1071 6.83621",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.760cb0e51c97ec8968bf1b9da626104b.svg";
export { ForwardRef as ReactComponent };